// Add your custom JS here.
import Splide from '@splidejs/splide';

// ─────────────────────────────────────────────────────────────
// Splide — generic init for any future sliders not handled by
// a dedicated block bundle.
// ─────────────────────────────────────────────────────────────
document.addEventListener( 'DOMContentLoaded', function () {
	function buildButtonVideoPlayer( trigger ) {
		var mode       = trigger.getAttribute( 'data-ov-video-mode' ) || 'file';
		var fileUrl    = trigger.getAttribute( 'data-ov-video-file' ) || '';
		var youtubeUrl = trigger.getAttribute( 'data-ov-video-youtube' ) || '';
		var vimeoUrl   = trigger.getAttribute( 'data-ov-video-vimeo' ) || '';

		if ( 'youtube' === mode && youtubeUrl ) {
			var youtubeFrame = document.createElement( 'iframe' );
			youtubeFrame.className = 'ov-btn-video-modal__embed';
			youtubeFrame.src = youtubeUrl;
			youtubeFrame.setAttribute( 'title', 'Video player' );
			youtubeFrame.setAttribute( 'allow', 'autoplay; fullscreen; picture-in-picture' );
			youtubeFrame.setAttribute( 'allowfullscreen', '' );
			youtubeFrame.setAttribute( 'referrerpolicy', 'strict-origin-when-cross-origin' );
			return youtubeFrame;
		}

		if ( 'vimeo' === mode && vimeoUrl ) {
			var vimeoFrame = document.createElement( 'iframe' );
			vimeoFrame.className = 'ov-btn-video-modal__embed';
			vimeoFrame.src = vimeoUrl;
			vimeoFrame.setAttribute( 'title', 'Video player' );
			vimeoFrame.setAttribute( 'allow', 'autoplay; fullscreen; picture-in-picture' );
			vimeoFrame.setAttribute( 'allowfullscreen', '' );
			vimeoFrame.setAttribute( 'referrerpolicy', 'strict-origin-when-cross-origin' );
			return vimeoFrame;
		}

		if ( fileUrl ) {
			var video = document.createElement( 'video' );
			video.className = 'ov-btn-video-modal__video';
			video.controls = true;
			video.autoplay = true;
			video.playsInline = true;
			video.src = fileUrl;
			return video;
		}

		return null;
	}

	function initGlobalButtonFormModal( trigger ) {
		var modalId = trigger.getAttribute( 'data-ov-form-modal-id' );
		if ( ! modalId ) {
			return;
		}

		var modal = document.getElementById( modalId );
		if ( ! modal ) {
			return;
		}

		// Move outside stacking contexts so fixed positioning always covers viewport.
		if ( modal.parentNode !== document.body ) {
			document.body.appendChild( modal );
		}

		var downloadUrl  = modal.getAttribute( 'data-ov-form-download-url' ) || '';
		var downloadName = modal.getAttribute( 'data-ov-form-download-name' ) || '';

		// If a download file is configured, inject a hidden field into the Forminator
		// form so the submission records which file was offered, then on success
		// reveal the download button inside the modal.
		//
		// Splide clones slides, duplicating the .forminator-custom-form wrapper.
		// Forminator may initialise on the clone so the success event fires outside
		// our moved modal. Listening on $(document) and matching by Forminator
		// module ID catches the event regardless of which DOM copy was used.
		if ( downloadUrl ) {
			var formEl = modal.querySelector( 'form' );
			if ( formEl ) {
				var hiddenInput = document.createElement( 'input' );
				hiddenInput.type  = 'hidden';
				hiddenInput.name  = 'downloaded_file';
				hiddenInput.value = downloadName || downloadUrl;
				formEl.appendChild( hiddenInput );
			}

			var formModuleId   = 'forminator-module-' + ( modal.getAttribute( 'data-ov-form-id' ) || '' );
			var downloadArea   = modal.querySelector( '.ov-btn-form-modal__download' );
			var $ = window.jQuery;
			if ( $ && formModuleId !== 'forminator-module-' && downloadArea ) {
				$( document ).on( 'forminator:form:submit:success', function ( e ) {
					if ( e.target && e.target.id === formModuleId ) {
						downloadArea.hidden = false;
					}
				} );
			}
		}

		var closeButtons = modal.querySelectorAll( '[data-ov-form-close]' );
		var previousActive = null;

		function onKeyDown( e ) {
			if ( 'Escape' === e.key ) {
				closeModal();
			}
		}

		function closeModal() {
			modal.hidden = true;
			document.body.classList.remove( 'ov-form-modal-open' );
			document.removeEventListener( 'keydown', onKeyDown );

			if ( previousActive && typeof previousActive.focus === 'function' ) {
				previousActive.focus();
			}
		}

		function openModal() {
			previousActive = document.activeElement;
			modal.hidden = false;
			document.body.classList.add( 'ov-form-modal-open' );
			document.addEventListener( 'keydown', onKeyDown );
		}

		trigger.addEventListener( 'click', openModal );

		closeButtons.forEach( function ( closeBtn ) {
			closeBtn.addEventListener( 'click', closeModal );
		} );
	}

	function initGlobalButtonVideoModal( trigger ) {
		var modalId = trigger.getAttribute( 'data-ov-video-modal-id' );
		if ( ! modalId ) {
			return;
		}

		var modal = document.getElementById( modalId );
		if ( ! modal ) {
			return;
		}

		// Keep modal outside block/sticky stacking contexts so fixed positioning
		// always covers the viewport (important inside transformed hero sections).
		if ( modal.parentNode !== document.body ) {
			document.body.appendChild( modal );
		}

		var playerHost = modal.querySelector( '[data-ov-video-player-host]' );
		var closeButtons = modal.querySelectorAll( '[data-ov-video-close]' );
		var previousActive = null;

		function onKeyDown( e ) {
			if ( 'Escape' === e.key ) {
				closeModal();
			}
		}

		function closeModal() {
			if ( playerHost ) {
				playerHost.innerHTML = '';
			}

			modal.hidden = true;
			document.body.classList.remove( 'ov-video-modal-open' );
			document.removeEventListener( 'keydown', onKeyDown );

			if ( previousActive && typeof previousActive.focus === 'function' ) {
				previousActive.focus();
			}
		}

		function openModal() {
			previousActive = document.activeElement;

			if ( playerHost ) {
				playerHost.innerHTML = '';
				var player = buildButtonVideoPlayer( trigger );
				if ( player ) {
					playerHost.appendChild( player );
				}
			}

			modal.hidden = false;
			document.body.classList.add( 'ov-video-modal-open' );
			document.addEventListener( 'keydown', onKeyDown );
		}

		trigger.addEventListener( 'click', openModal );

		closeButtons.forEach( function ( closeBtn ) {
			closeBtn.addEventListener( 'click', closeModal );
		} );
	}

	// Generic fallback for sliders without a dedicated initialiser.
	// Skip sliders already mounted by a block script, and store the instance
	// on the element so block scripts can destroy it before re-mounting.
	var sliders = document.querySelectorAll( '.splide:not([data-categories-splide]):not([data-testimonials-splide])' );
	sliders.forEach( function ( slider ) {
		if ( slider._splide || slider.classList.contains( 'is-initialized' ) ) {
			return;
		}
		slider._splide = new Splide( slider ).mount();
	} );

	document.querySelectorAll( '[data-ov-video-open]' ).forEach( function ( trigger ) {
		initGlobalButtonVideoModal( trigger );
	} );

	document.querySelectorAll( '[data-ov-form-open]' ).forEach( function ( trigger ) {
		initGlobalButtonFormModal( trigger );
	} );

	var headerWrap = document.getElementById( 'wrapper-navbar' );
	if ( headerWrap ) {
		var ticking = false;

		function syncHeaderScrolledState() {
			headerWrap.classList.toggle( 'is-scrolled', window.scrollY > 8 );
			ticking = false;
		}

		window.addEventListener( 'scroll', function () {
			if ( ticking ) {
				return;
			}
			ticking = true;
			window.requestAnimationFrame( syncHeaderScrolledState );
		} );

		syncHeaderScrolledState();
	}

	// Smooth-scroll same-page anchors with a fixed-nav offset.
	// Clamp at 0 so near-top targets never produce a cropped state.
	document.addEventListener( 'click', function ( event ) {
		var link = event.target.closest( 'a[href*="#"]' );
		if ( ! link ) {
			return;
		}

		if ( link.target && '_self' !== link.target ) {
			return;
		}

		if ( link.hasAttribute( 'data-bs-toggle' ) || link.closest( '[data-bs-toggle]' ) ) {
			return;
		}

		var href = link.getAttribute( 'href' ) || '';
		if ( ! href || '#' === href ) {
			return;
		}

		var url;
		try {
			url = new URL( href, window.location.href );
		} catch ( err ) {
			return;
		}

		if ( url.origin !== window.location.origin || url.pathname !== window.location.pathname || ! url.hash ) {
			return;
		}

		var targetId = decodeURIComponent( url.hash.slice( 1 ) );
		if ( ! targetId ) {
			return;
		}

		var targetEl = document.getElementById( targetId );
		if ( ! targetEl ) {
			return;
		}

		event.preventDefault();

		var navOffsetRaw = window.getComputedStyle( document.documentElement ).getPropertyValue( '--ov-nav-offset' );
		var navOffset = parseFloat( navOffsetRaw ) || 86;
		var targetTop = targetEl.getBoundingClientRect().top + window.pageYOffset - navOffset;

		if ( targetTop < 0 ) {
			targetTop = 0;
		}

		window.history.pushState( null, '', url.hash );
		window.scrollTo( { top: targetTop, behavior: 'smooth' } );
	} );
} );
